// extracted by mini-css-extract-plugin
var _1 = "Tooltip__bg--IajhH";
var _2 = "Tooltip__content--Ac2WF";
var _3 = "Tooltip__hidden--ze_Om";
var _4 = "Tooltip__large--yDlxC Tooltip__text--fYOc5 CoreGeneral__robotoSlab--X8lgW";
var _5 = "Tooltip__medium--AsyoI Tooltip__text--fYOc5 CoreGeneral__robotoSlab--X8lgW";
var _6 = "Tooltip__medium-wrap--FxFR0 Tooltip__text--fYOc5 CoreGeneral__robotoSlab--X8lgW";
var _7 = "Tooltip__outer--NPnXI";
var _8 = "Tooltip__small--UsNl2 Tooltip__text--fYOc5 CoreGeneral__robotoSlab--X8lgW";
var _9 = "Tooltip__text--fYOc5 CoreGeneral__robotoSlab--X8lgW";
export { _1 as "bg", _2 as "content", _3 as "hidden", _4 as "large", _5 as "medium", _6 as "medium-wrap", _7 as "outer", _8 as "small", _9 as "text" }
